import React, { useState } from "react";

import Container from "./Plans_css"
const Index = ({ data }) => {
   const [showMore1, setShowMore1] = useState(false);
   const [showMore2, setShowMore2] = useState(false);
   const [showMore3, setShowMore3] = useState(false);

   var arrPrice = [];
   try {
      arrPrice = JSON.parse(data.data[0].jsonpricing_text);
      if (arrPrice.instalment_conditions) {
         var cash = arrPrice.instalment_conditions.filter(
             (c) => c.instalment_conditions_mode_id === "0"
         );
         var check = arrPrice.instalment_conditions.filter(
             (c) =>
                 c.instalment_conditions_mode_id === "1" ||
                 c.instalment_conditions_mode_id === "3"
         );
      }
   } catch (e) {
      console.log(e);
   }


   let al = arrPrice.instalment_conditions;

   if (arrPrice.instalment_conditions) {
      al.sort(function (a, b) {
         // console.log("b: ", b)
         return (
             Number(a.instalment_conditions_date) -
             Number(b.instalment_conditions_date)
         );
      });
   }

   var active_star =
       parseInt(arrPrice.company_customer_satisfaction) +
       parseInt(arrPrice.company_levelof_prosperity) +
       parseInt(arrPrice.company_timeanswer_complaints);

   active_star = Math.ceil(active_star / 3 / 2);
   var deactive_star = 5 - active_star;

   const Stars = () => {
      var stars = [];
      for (var i = 0; i < active_star; i++) {
         stars.push(
             <img src="/imagess/star.png" key={i + deactive_star} alt="star icon" />
         );
      }
      return <>{stars}</>;
   };

   const Stars_ = () => {
      var dstars = [];
      for (var i = 0; i < deactive_star; i++) {
         dstars.push(<img src="/imagess/star_.png" key={i} alt="star icon" />);
      }
      return <>{dstars}</>;
   };

   function formatPrice(value) {
      return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
   }

   const handleClick = (id) => {
      if (id === 1) {
         setShowMore1(!showMore1);
      } else if (id === 2) {
         setShowMore2(!showMore2);
      } else if (id === 3) {
         setShowMore3(!showMore3);
      }
   };
   var Coverage = []
   var ExtraCoverage = []

   try {


      Coverage = data.data[0].packageinsurance_coverage.split("-")

      ExtraCoverage = data.data[0].packageinsurance_extracoverage.split("-")
   } catch (e) {
      console.log(e)
   }
   // *******************component************component*******************component*****************component*************

   const Text = (props) => {
      return (
          <Container>
             <div  className="main-textt">
                <div className="text-title">{props.title}</div>
                <div className="text-detail">{props.detail}</div>
             </div>
          </Container>
      );
   };

   const Linetitle = (props) => {
      return (
          <Container>
             <div className="main-line">
                <div style={{ width: "100%" }} className="line">
                   <div style={{ width: props.w }} className="line-text">
                      {props.name}
                   </div>
                </div>
             </div>
          </Container>
      );
   };
   return (
       <Container>
          <div className="main-map-detail">
             <div className="title">
                خلاصه سفارش بیـــمه
                <span
                    style={{
                       color: "#1ad4a3",
                       marginRight: "5px",
                       display: "flex",
                    }}
                >
                    {arrPrice.fieldinsurance_fa}
              </span>
             </div>
             <Linetitle name="پوشش های پایه" />
             <div className="map-detail-divv">
                {Coverage.map((i, index) => {
                   return (
                       <Text title=" " detail={i} />
                   )
                })}



             </div>

             <Linetitle name="پوشش های اضافی" />
             <div className="map-detail-divv">
                {ExtraCoverage.map((i, index) => {
                   return (
                       <Text
                           title=""
                           detail={i}
                       />

                   )
                })}
             </div>

             <Linetitle name="اطلاعات بیمه" />
             <div className="map-detail-divv">
                <Text title="نام بیمه" detail={arrPrice.company_name} />
                <Text title="امتیاز بیمه" detail={arrPrice.company_levelof_prosperity} />
                <Text
                    title="مبلغ بیمه"
                    detail={`${formatPrice(arrPrice.price)} ریال`}
                />
                <Text
                    title="درصد تخفیف مدیریتی"
                    detail={
                       arrPrice.managdiscount_amount
                           ? `${arrPrice.managdiscount_amount} درصد`
                           : "ندارد"
                    }
                />

                <Text
                    title="امکان خرید اقساطی"
                    detail={arrPrice.instalment_conditions ? "بله" : "خیر"}
                />
                <>
                   {arrPrice.instalment_conditions && arrPrice.instalment_conditions.map((data) => (
                       <Text
                           title={data.instalment_conditions_desc}
                           detail={data.instalment_conditions_amount}
                       />
                   ))}
                </>

             </div>
          </div>
       </Container>
   );
};

export default Index;
